const ACTION_QUEUE_PROCESSING_INTERVAL = 50

export default class ActionsQueue extends Array {
  constructor(handlers) {
    super()
    this._loopTimeout = null
    this._handlers = handlers
    this._running = false
    this._processPromisesResolvers = []
  }

  fill(actions) {
    const promise = new Promise((resolve, reject) => {
      this._processPromisesResolvers.push(resolve)
    })

    if (this.length === 0) {
      super.push({ _queueStart: null })
    }

    actions.forEach((action) => super.push(action))

    if (this.length) {
      super.push({ _queueComplete: null })
    }

    return promise
  }

  start() {
    if (!this._running) {
      this._running = true
      this._loop()
    }
  }

  stop() {
    if (this._running) {
      this._running = false
      clearTimeout(this._loopTimeout)
    }
  }

  async _loop() {
    if (this._running) {
      let actionObj = this.splice(0, 1)

      actionObj = actionObj && actionObj.length ? actionObj[0] : null

      if (actionObj) {
        const name = Object.keys(actionObj)[0]

        console.log('Queue::_loop', name, actionObj[name])

        if (!this._handlers[name]) {
          console.warn('Queue:_loop: unhandled action: ', name)
        }

        const result = this._handlers[name]
          ? this._handlers[name](actionObj[name])
          : null;

        if (result instanceof Promise) {
          result.then(() => {
            this._loopTimeout = setTimeout(
              this._loop.bind(this),
              ACTION_QUEUE_PROCESSING_INTERVAL
            )
          })
        } else {
          this._loopTimeout = setTimeout(
            this._loop.bind(this),
            ACTION_QUEUE_PROCESSING_INTERVAL
          )
        }
      } else {
        this._loopTimeout = setTimeout(
          this._loop.bind(this),
          ACTION_QUEUE_PROCESSING_INTERVAL
        )

        while (this._processPromisesResolvers.length) {
          this._processPromisesResolvers.pop()()
        }
      }
    }
  }
}
